export default {
  namespaced: true,
  state: {
    resultsFilters: {
      type: null,
      status: null,
      source: null,
    },
    datesData: {
      dates: [],
      dateType: 0,
    },
    overviewModus: "overview",
    selectedPayments: [],
  },
  mutations: {
    setResultsFilters: (state, filters) => {
      state.resultsFilters = filters;
    },
    setDatesData: (state, data) => {
      state.datesData = data;
    },
    setOverviewModus: (state, view) => {
      state.overviewModus = view;
    },
    setSelectedPayments: (state, selection) => {
      state.selectedPayments = selection;
    },
  },
  actions: {
    setResultsFilters: (context, filters) => {
      context.commit("setResultsFilters", filters);
      context.commit("setSelectedPayments", []);
    },
    setDatesData: (context, data) => {
      context.commit("setDatesData", data);
    },
    setOverviewModus: (context, view) => {
      context.commit("setOverviewModus", view);
    },
    setSelectedPayments: (context, selection) => {
      context.commit("setSelectedPayments", selection);
    },
    resetOverview: (context) => {
      context.commit("setSelectedPayments", []);
      context.commit("setOverviewModus", "overview");
      context.commit("setResultsFilters", {
        type: null,
        status: null,
        source: null,
      });
    },
  },
};
